import { useLocation } from 'react-router-dom'
import { useQuery } from '../../../routes'
import { PaginationEntry, AdminUser } from '../../../queries/types'
import { useAccessLevelFilters } from './AccessLevelFilters'
import { useAdminUsers } from '../../../queries'

const PAGE_LIMIT = 25

export const usePaginatedRoles = () => {
  const query = useQuery<{ page?: number; after?: string }>()

  const { accessLevel } = useAccessLevelFilters()
  const { search } = useLocation()
  const after = query.search.after || undefined

  const { data, isLoading: loading, error } = useAdminUsers({
    accessLevel,
    first: PAGE_LIMIT,
    after,
  })

  const currentPage = parseInt(`${query.search.page || 1}`, 0)
  const users = data?.admins ?? ([] as AdminUser[])
  const pageInfo = data?.pagination

  interface IPageClickGeneratorProp {
    historyPush?: boolean
  }
  const handlePageClick = (p?: IPageClickGeneratorProp) => ({
    page,
    cursor,
  }: {
    page: number
    cursor: string
  }) => {
    query.set(
      { ...query.search, after: cursor, page },
      p ? p.historyPush : false
    )
  }

  return {
    accessLevel,
    currentPage,
    error,
    users,
    handlePageClick,
    loading,
    nextPages: pageInfo?.hasMore ? [{ page: currentPage + 1, cursor: '' }] : [],
    pageInfo,
    prevPages:
      pageInfo && pageInfo.offset > 0
        ? [{ page: currentPage - 1, cursor: '' }]
        : [],
    query,
    search,
  }
}
